import { atom } from "recoil";
import SaleBusModel from "../Models/SaleBusModel";

export const SaleBusState = new atom({
  default: new SaleBusModel(),
  key: "SaleBusState",
});
